export const GLOBAL_CLASS_NAME = 'standard-mode'

export const ANIMATION_TYPE_SQUARES_ROTATING   = 'suqares-rotating'
export const ANIMATION_TYPE_SQUARES_ASCENDING  = 'suqares-ascending'
export const ANIMATION_TYPE_STRIPES_HORIZONTAL = 'stripes-horizontal'
export const ANIMATION_TYPE_STRIPES_VERTICAL   = 'stripes-vertical'

export const ANIMATION_SQUARES_LIMIT   = 5
export const ANIMATION_STRIPES_LIMIT   = 5

export const IP_GEOLOCATION_API = "87256dff52324bdb9ef16b08518779b4"